<button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="goToPayment()">{{ buttonText | translate }}</button>
